import { useEffect, useState } from "react";
import CustomModel from "../../components/custom-model/CustomModel";
import { addUserSchema } from "../../utils/formik/validationSchema";
import { addUserValues } from "../../utils/formik/initialValues";
import SubAdminApi from "../../services/subAdminService";
import { notify } from "../../bmr/utils/methods/notification";

const normalizeCountryCode = (value) => {
  const code = String(value || "91").replace(/\D/g, "");
  return code || "91";
};

function SubAdminEdit({
  openModal,
  setOpenModal,
  id = "",
  subAdminDetail,
  roleList,
  getSubAdmin,
}) {
  const [initialValues, setInitialValues] = useState(addUserValues);
  const [submitLoading,setSubmitLoading] = useState(false);
  const [modelData, setModelData] = useState({
    title: "Add User",
    editTitle: "Edit User",
    children: [
      {
        type: "dropdown",
        name: "userType",
        label: "User Type",
        placeholder: "Enter Type",
        data: roleList,
        IsRequired: true,
      },
      {
        type: "input",
        name: "name",
        label: "Name",
        placeholder: "Enter Name",
        IsRequired: true,
      },
      {
        type: "input",
        name: "email",
        label: "Email",
        placeholder: "Enter Email",
        IsRequired: true,
      },
      {
        type: "phone",
        name: "phoneNumber",
        label: "Phone Number",
        placeholder: "Enter Phone Number",
        countryCodeName: "countryCode",
        defaultCountry: "in",
        IsRequired: true,
      },
    ],
  });  

  useEffect(() => {
    setInitialValues({
      userType: subAdminDetail?.role_id,
      name: subAdminDetail?.name,
      email: subAdminDetail?.email,
      countryCode: normalizeCountryCode(subAdminDetail?.country_code),
      phoneNumber: subAdminDetail?.phone,
      selectTrial: subAdminDetail?.phase_id,
    });
  }, [subAdminDetail]);

  useEffect(() => {
    const newChildren = [
      {
        type: "input",
        name: "name",
        label: "Name",
        placeholder: "Enter Name",
        IsRequired: true,
      },
      {
        type: "phone",
        name: "phoneNumber",
        label: "Phone Number",
        placeholder: "Enter Phone Number",
        countryCodeName: "countryCode",
        defaultCountry: "in",
        IsRequired: true,
      },
    ];

    if (id == "") {
      newChildren.push({
        type: "input",
        name: "email",
        label: "Email",
        placeholder: "Enter Email",
        IsRequired: true,
      });
      newChildren.unshift({
        type: "dropdown",
        name: "userType",
        label: "Onboard Users Type",
        placeholder: "Enter Type",
        data: roleList,
        IsRequired: true,
      })
    } else {
      newChildren.push({
        type: "input",
        name: "email",
        label: "Email",
        placeholder: "Enter Email",
        IsRequired: true,
        disabled: true,
      });
      newChildren.unshift({
        type: "dropdown",
        name: "userType",
        label: "Onboard Users Type",
        placeholder: "Enter Type",
        data: roleList,
        IsRequired: true,
        disabled: true,
      })
    }
    setModelData((prevModelData) => ({
      ...prevModelData,
      children: newChildren,
    }));
  }, [id]);

  const handleEditModelValues = (values) =>{
    setOpenModal(false);
    setSubmitLoading(false);
    SubAdminApi.editSubAdmin(
      {
        name: values?.name,
        email: values?.email,
        country_code: normalizeCountryCode(values?.countryCode),
        phone: values?.phoneNumber?.toString(),
        role_id: values?.userType,
      },
      id
    )
      .then((res) => {
        if (res.status === 200) {
          setSubmitLoading(false);
          getSubAdmin();
          notify.success(res?.message)
        }
      })
      .catch((error) => { 
          notify.error(error)
      });}
  return (
    <>
      <CustomModel
        rowId={id}
        modalInitialValues={initialValues}
        initialValuesValidationSchema={addUserSchema}
        open={openModal}
        setOpen={setOpenModal}
        setModelData={setModelData}
        modelData={modelData}
        handleModelValues={handleEditModelValues}
        isLoadingBtn={submitLoading}
      />
    </>
  );
}

export default SubAdminEdit;
